import React from 'react';
import { useTranslation } from 'react-i18next';
import { getProjectImgAndShareIcon } from 'utils/projectHelpers';

const ProjectBlockItem = ({ item, className = '', onProjectClick }) => {
  const { t } = useTranslation();
  const { image, isNoImage } = getProjectImgAndShareIcon(item);

  return (
    <div
      className={`project-block ${className} ${onProjectClick ? 'pointer' : ''}`}
      onClick={onProjectClick}
      role='button'
      tabIndex={-1}
    >
      <div className={`project-image ${isNoImage ? 'no-image' : ''}`}>
        <div className='d-flex flex-column justify-content-center align-items-center h-100 lh-initial'>
          <img src={image} alt={item.name} />
        </div>
      </div>
      <div className='project-info mt-5 mt-md-8'>
        <p className='mb-3 mb-md-6 text-lg fw-500'>{item.name}</p>
        <p className='mb-0 text-gray-dark fw-300 d-flex justify-content-between'>
          <span>
            {item.itemsCount} {t('text_products')}
          </span>
        </p>
      </div>
    </div>
  );
};

export default ProjectBlockItem;
